import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SystemService } from 'src/app/services/system.service';
import * as pistols from 'src/assets/json/pistols.json';
import * as colors from 'src/assets/json/colors.json';
import * as lights from 'src/assets/json/lights.json';

@Component({
	selector: 'app-stowaway',
	templateUrl: './stowaway.component.html',
})
export class StowawayComponent implements OnInit {
	holster: any = {
		type: "holster",
		hand: "Right",
		style: "IWB",
		shield: false,
		layers: 1,
		layer1: "Blizzard White",
		layer2: "Tactical Black",
		felt: "felt",
		buckle: "FOMI",
		image: null,
		reddot: false,
		pistols: [{ make: null, model: null, qty: 1 }],
		price: 100
	}

	images: any[] = [
		{ image: 'assets/images/art/1.png', description: "1 sided print. Classic. Vintage." },
		{ image: 'assets/images/art/2.png', description: "2 sided print, full bleed. Show your support for 9/11!" },
		{ image: 'assets/images/art/3.png', description: "2 sided print, full bleed. Italian flag with skull in the middle." },
		{ image: 'assets/images/art/4.png', description: "1 sided print. She's gangsta! Classic. Vintage." },
		{ image: 'assets/images/art/5.png', description: "2 sided print, full bleed. Modern camo in blue and black." },
		{ image: 'assets/images/art/6.png', description: "2 sided print, full bleed. Modern camo in yellow and black." },
		{ image: 'assets/images/art/7.png', description: "2 sided print, full bleed. Modern camo in blue and black." },
		{ image: 'assets/images/art/8.png', description: "2 sided print, full bleed. Skull in blue and orange against black background." },
		{ image: 'assets/images/art/9.png', description: "2 sided print, full bleed. Warrior in lake surrounded by flowers." },
		{ image: 'assets/images/art/10.png', description: "2 sided print, full bleed. Warriors in field. Blue and black." },
	]

	samples: any[] = [
		{ small: "assets/images/holsters/holster_1.png", big: "assets/images/holsters/holster1_big.png" },
		{ small: "assets/images/holsters/holster_3.png", big: "assets/images/holsters/holster3_big.png" },
		{ small: "assets/images/holsters/holster_2.png", big: "assets/images/holsters/holster_2.png" },
	]
	selectedSample: any;

	manufacturer: any[] = (pistols as any).default['pistols'];
	colors: any[] = (colors as any).default['colors'];
	lights: any[] = (lights as any).default['lights'];

	constructor(
		private messageService: MessageService,
		private systemService: SystemService
	) {

	}

	ngOnInit(): void {
		this.selectedSample = this.samples[0];

		console.log(this.manufacturer);
		let tot1 = 0;
		let tot2 = 0;
		this.manufacturer.forEach(man => {
			tot1++;
			man.models.forEach(make => {
				tot2++;

			});
		})
		console.log(tot1);
		console.log(tot2);
	}

	addPistol() {
		this.holster.pistols.push({ make: {}, model: "", qty: 1 })
	}

	getTotal() {
		let price = 60;
		let total = 0;
		switch (this.holster.buckle) {
			case "FOMI":
				price += 5;
				break;
			case "G-Code":
				price += 5;
				break;
		}
		if(this.holster.layers == 2) { price += 5;}

		this.holster.pistols.forEach(pistol => {
			let tmp = pistol.qty * price;
			total = total + tmp;
		});
		return total;
	}

	addToCart() {
		console.log(this.holster);
		if ((!this.holster.pistols[0].make) && (!this.holster.pistols[0].model)) {
			this.messageService.add({ key: "general", severity: 'error', summary: 'Cart', detail: 'Please select a pistol make and model.' });
			return false;
		}
		let cart = [];
		if (localStorage.getItem('cart')) { cart = JSON.parse(localStorage.getItem('cart')) };
		this.holster.pistols.forEach(pistol => {
			// let item = pistol;
			let item = {
				type: this.holster.type,
				hand: this.holster.hand,
				style: this.holster.style,
				shield: this.holster.shield,
				layers: this.holster.layers,
				layer1: this.holster.layer1,
				layer2: this.holster.layer2,
				felt: this.holster.felt,
				buckle: this.holster.buckle,
				image: this.holster.image,
				reddot: this.holster.reddot,
				price: this.getTotal(),
				make: pistol.make.label,
				model: pistol.model,
				light: pistol.light ? pistol.light : "None",
				qty: pistol.qty
			}
			cart.push(item);
		});
		console.log("Cart", cart);
		this.systemService.saveCartToStorage(cart);

		this.systemService.cartUpdated.next("");
		this.messageService.add({ key: "create", severity: 'success', summary: 'Cart', detail: 'Holster added!' });
	}

	removePistol(index) {
		this.holster.pistols.splice(index, 1);
	}
}
